import { useTranslation } from "react-i18next";

export default function Diensten() {
  const { t } = useTranslation("slotenmaker-eindhoven");
  const items = t("diensten.items", { returnObjects: true }) as Array<{
    title: string;
    text: string;
    linkText?: string;
    linkHref?: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
          {t("diensten.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 max-w-[900px] mb-10 md:mb-14 leading-relaxed">
          {t("diensten.intro")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 md:p-8 border border-brand-border/60"
            >
              <h3 className="font-geist font-bold text-lg text-brand-text mb-3">
                {item.title}
              </h3>
              <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed mb-4">
                {item.text}
              </p>
              {item.linkHref && item.linkText && (
                <a
                  href={item.linkHref}
                  className="inline-flex items-center gap-1 font-geist text-sm font-semibold text-brand-blue hover:underline"
                >
                  {item.linkText}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}